'use client';

import { createPortal } from 'react-dom';
import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { usePresentationScope } from '../../lib/presentation-context';
import { cn } from '../../lib/utils';

function Toaster({ className, ...props }: ToasterProps) {
  const scope = usePresentationScope();
  const toaster = (
    <Sonner
      className={cn('toaster group', scope && 'presentation-toaster', className)}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
      hotkey={scope ? [] : props.hotkey}
    />
  );
  return scope ? scope.container && createPortal(toaster, scope.container) : toaster;
}

export { Toaster };
